import { Text, Pressable, Platform } from 'react-native';
import gs from '../../styles/globalStyles';
import FilledCheckMarkIcon from '../../../assets/Icons/FilledCheckMark';
import EmptyCheckMarkIcon from '../../../assets/Icons/EmptyCheckMark';
import { checkColor } from '@app/utils';
import { useTheme } from '@shopify/restyle';
import { Theme } from '@app/theme';


const CheckBox = ({
  size = 12,
  label = null,
  isChecked = false,
  onToggle = () => {},
}) => {

  const {colors} = useTheme<Theme>()
  return (
    <Pressable hitSlop={{top : 20 , left :20 , right : 20 , bottom : 20}} onPress={onToggle} style={[gs.setMarginRight(4)]}>
      {isChecked ? (
        <FilledCheckMarkIcon check={colors['bg-fill-primary']} size={size} color={colors['icon-action-primary']} />
      ) : (
        <EmptyCheckMarkIcon size={size} />
      )}
      {label && <Text>{label}</Text>}
    </Pressable>
  );
};

export default CheckBox;
